import { Link } from "react-router-dom";
import { Logo } from "../../components/Logo";

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#000000] px-6 py-16">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[600px] -translate-x-1/2 rounded-full bg-white/15 blur-[150px]" />
      <div className="relative w-full max-w-md">
        <div className="mb-8 text-center">
          <Logo className="h-9" />
        </div>
        <div className="glass rounded-3xl p-8 md:p-10">
          <h1 className="font-display text-3xl font-extrabold tracking-tighter text-white">
            {title}
          </h1>
          {subtitle && <p className="mt-2 text-white/75">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
        <div className="mt-6 text-center">
          {footer}
          <Link
            to="/"
            className="mt-4 block font-mono text-xs uppercase tracking-[0.2em] text-white/70 hover:text-white/75 transition-colors"
          >
            ← Back to site
          </Link>
        </div>
      </div>
    </div>
  );
}
